var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
    style: { "width": "936px" },
    class: "h-full bg-gray-100 flex flex-col space-y-4"
};
const _hoisted_2 = {
    ref: "tuiImageEditor",
    class: "flex flex-col items-center justify-center w-full relative",
    style: { "height": "480px" }
};
const _hoisted_3 = {
    class: "items-center justify-center flex flex-col bg-transparent",
    style: { "width": "600px", "height": "400px" }
};
const _hoisted_4 = {
    ref: "canvasRef",
    id: "img-editor-container",
    width: "600",
    height: "400"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "absolute top-0 left-0 items-center justify-center flex flex-col bg-gray-100 w-full h-full hidden" }, [
    /*#__PURE__*/ _createElementVNode("canvas", {
        id: "img-editor-temp-container",
        width: "200",
        height: "200"
    })
], -1);
import Options from '@/components/options/ImageOptions.vue';
import ModalHeader from '@/components/options/ModalHeaderV2.vue';
import CropSubTool from '@/components/options/tools/CropSubTool.vue';
import { dataURLtoBlob } from '@/compositions/useDataUrlToBlob';
import fabric from '@/compositions/useFabricObject';
import { useImageSize } from '@/compositions/useImageSize';
import { MediaService } from '@/services/MediaService';
import { Tools } from '@/types/tools';
import { UIModal, UIModalFooter, UIModalHeader, UISpin, } from '@gohighlevel/ghl-ui';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageEditor',
    props: {
        imageUrl: {
            type: String,
            require: true,
        },
        imageName: {
            type: String,
            require: true,
        },
        locationId: {
            type: String,
            require: true,
        },
    },
    emits: ['close', 'done'],
    setup(__props, { emit: emits }) {
        const props = __props;
        let canvas, cropper, cropperTempCanvas;
        const cropperImage = ref('');
        const showModal = ref(true);
        const selectedOption = ref(Tools.CROP);
        const bgImage = ref();
        const bgImageWidth = ref();
        const bgImageHeight = ref();
        const showLoader = ref(true);
        const firstLoad = ref(true);
        const saveLoader = ref(false);
        const createFrames = ref(false);
        const cropperCanvas = ref();
        const aspectRatio = ref(NaN);
        const cropperChangeDetect = ref(false);
        const croppedImage = ref();
        const reset = ref(false);
        const imageSize = ref();
        const hideFabric = ref(false);
        const cropperAspectRatio = computed(() => aspectRatio);
        const cropperOptions = ref({
            aspectRatio: cropperAspectRatio.value,
            class: 'cropper-stencil',
            previewClass: 'cropper-stencil__preview',
            draggingClass: 'cropper-stencil--dragging',
            handlersClasses: {
                default: 'cropper-handler',
                eastNorth: 'cropper-handler--east-north',
                westNorth: 'cropper-handler--west-north',
                eastSouth: 'cropper-handler--east-south',
                westSouth: 'cropper-handler--west-south',
            },
        });
        const showFabric = computed(() => selectedOption.value !== Tools.CROP && !hideFabric.value);
        const showCropper = computed(() => selectedOption.value === Tools.CROP);
        const imageSrc = computed(() => props.imageUrl);
        const isLoading = computed(() => createFrames.value || showLoader.value);
        onMounted(() => {
            cropperImage.value = imageSrc.value;
            if (props.imageUrl) {
                startEditor();
            }
        });
        onUnmounted(() => {
            try {
                canvas.clear();
                cropper.clear();
            }
            catch (error) {
                // console.log('Error with cropper destroy')
            }
        });
        watch(showCropper, () => {
            handleConflict();
        });
        watch(imageSrc, () => {
            if (imageSrc.value) {
                cropperImage.value = imageSrc.value;
                startEditor();
            }
        });
        function startEditor() {
            return __awaiter(this, void 0, void 0, function* () {
                initializeFabric();
                handleConflict();
                initializeCropperCanvas(imageSrc.value, []);
                const { size } = yield useImageSize(imageSrc.value);
                imageSize.value = size;
            });
        }
        function initializeFabric() {
            if (canvas)
                return;
            canvas = new fabric.Canvas('img-editor-container');
            setBackgroundFromDataUrl(props.imageUrl, true);
        }
        function handleConflict() {
            const canvasContainer = document.getElementsByClassName('canvas-container');
            if (canvasContainer.length) {
                showCropper.value
                    ? canvasContainer[0].classList.add('hidden')
                    : canvasContainer[0].classList.remove('hidden');
            }
        }
        function setBackgroundFromDataUrl(dataUrl, cloneObject) {
            canvas.clear();
            fabric.Image.fromURL(dataUrl, function (img) {
                // Get the canvas dimensions
                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;
                const imageAspectRatio = img.width / img.height;
                const canvasAspectRatio = canvasWidth / canvasHeight;
                let scaleFactor;
                if (imageAspectRatio >= canvasAspectRatio) {
                    // Fit the image width to the canvas
                    scaleFactor = canvasWidth / img.width;
                }
                else {
                    // Fit the image height to the canvas
                    scaleFactor = canvasHeight / img.height;
                }
                // Calculate the new image dimensions
                const newWidth = img.width * scaleFactor;
                const newHeight = img.height * scaleFactor;
                // Get the image dimensions
                bgImageWidth.value = img.width;
                bgImageHeight.value = img.height;
                img.set({
                    left: 0,
                    top: 0,
                    cache: true,
                    centeredRotation: true,
                    selectable: false,
                });
                img.scaleToWidth(newWidth);
                img.scaleToHeight(newHeight);
                canvas.add(img);
                canvas.centerObject(img);
                canvas.renderAll();
                if (cloneObject) {
                    bgImage.value = fabric.util.object.clone(img);
                    createFrames.value = true;
                }
                setTimeout(() => {
                    showLoader.value = false;
                }, 500);
            }, { crossOrigin: 'anonymous' });
        }
        function setSelectedOption(val) {
            if (selectedOption.value == Tools.CROP &&
                val !== Tools.CROP &&
                cropperChangeDetect.value) {
                cropperChangeDetect.value = false;
                setBackgroundFromDataUrl(croppedImage.value);
            }
            selectedOption.value = val;
            canvas.isDrawingMode = false;
            if (val == Tools.BRUSH) {
                canvas.isDrawingMode = true;
            }
        }
        function downloadImage() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (saveLoader.value)
                        return;
                    saveLoader.value = true;
                    let quality = 1;
                    if (imageSize.value > 5242880)
                        quality = 0.7;
                    const { canvas } = cropperCanvas.value.getResult();
                    const downloadImageData = canvas.toDataURL('image/jpeg', quality);
                    const blob = dataURLtoBlob(downloadImageData);
                    yield uploadImage(blob);
                    saveLoader.value = false;
                }
                catch (error) {
                    // Handle Error
                    saveLoader.value = false;
                }
            });
        }
        function setBrushSettings(data) {
            canvas.freeDrawingBrush.width = data.width;
            canvas.freeDrawingBrush.color = data.color;
        }
        function cropperChange(data) {
            if (selectedOption.value === Tools.CROP) {
                cropperChangeDetect.value = true;
                const { canvas } = cropperCanvas.value.getResult();
                if (canvas) {
                    croppedImage.value = canvas.toDataURL();
                }
                if (data.flip || data.angle) {
                    const image = cropperTempCanvas.item(0);
                    if (data.flip) {
                        image.set(data.flip, !image[data.flip]);
                    }
                    else if (data.angle) {
                        const rotate = image.angle + data.angle;
                        image.set({ angle: rotate });
                    }
                    cropperTempCanvas.renderAll();
                }
            }
        }
        function fabricChange() {
            const firstImage = canvas.item(0); // Assuming the first object is the image
            if (firstImage.filters) {
                setTimeout(() => {
                    const tempImg = cropperTempCanvas.item(0);
                    tempImg.filters = firstImage.filters;
                    tempImg.applyFilters();
                    const { coordinates } = cropperCanvas.value.getResult();
                    cropperImage.value = tempImg.toDataURL();
                    cropperCanvas.value.update();
                    cropperCanvas.value.setCoordinates(coordinates);
                }, 200);
            }
        }
        function initializeCropperCanvas(croppedImageData, filters) {
            try {
                if (cropperTempCanvas)
                    cropperTempCanvas.clear();
                cropperTempCanvas = new fabric.Canvas('temp-canvas');
                fabric.Image.fromURL(croppedImageData, function (img) {
                    img.set({
                        left: 0,
                        top: 0,
                        cache: true,
                        centeredRotation: true,
                        selectable: false,
                    });
                    if (filters.length) {
                        img.filters = filters;
                        img.applyFilters();
                    }
                    cropperTempCanvas.add(img);
                    cropperTempCanvas.renderAll();
                }, { crossOrigin: 'anonymous' });
            }
            catch (error) {
                // console.log('Cropper Temp Canvas Error', error)
            }
        }
        function resetAll() {
            //Reset Fabric
            reset.value = true;
            showLoader.value = true;
            setBackgroundFromDataUrl(props.imageUrl);
            // Reset Cropper
            cropperImage.value = imageSrc.value;
            cropperCanvas.value.update();
            setTimeout(() => {
                reset.value = false;
            }, 300);
        }
        function closeEditor() {
            emits('close');
        }
        function uploadImage(imageData) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const imageName = `${props.imageName.split('.')[0]}.jpeg`;
                    const { data } = yield MediaService.initializeUpload({
                        altId: props.locationId,
                        altType: 'location',
                        name: imageName,
                        size: imageData.size,
                        contentType: 'image/jpeg',
                        parentId: '',
                    });
                    if (data.aknId && data.url) {
                        yield MediaService.uploadBlob(data.url, imageData);
                        const completedMedia = yield MediaService.finalizeUpload({
                            altId: props.locationId,
                            altType: 'location',
                            id: data.aknId,
                        });
                        if (completedMedia.data && completedMedia.data.url) {
                            emits('done', completedMedia.data.url);
                        }
                    }
                }
                catch (error) {
                    // error to handle error message
                }
            });
        }
        function disableLoading() {
            createFrames.value = false;
        }
        function cropperReady() {
            try {
                if (firstLoad.value) {
                    setCropBox();
                    const { canvas } = cropperCanvas.value.getResult();
                    const croppedImageData = canvas.toDataURL();
                    initializeCropperCanvas(croppedImageData, []);
                }
                firstLoad.value = false;
                showLoader.value = false;
            }
            catch (error) {
                // console.log('Cropper Ready Error', error)
                // handle error
            }
        }
        function setCropBox() {
            const { image } = cropperCanvas.value.getResult();
            cropperCanvas.value.setCoordinates({
                left: 0,
                top: 0,
                width: image.width,
                height: image.height,
            });
            showLoader.value = false;
        }
        function setAspectRatio(ratio) {
            aspectRatio.value = ratio;
            if (isNaN(aspectRatio.value)) {
                setCropBox();
            }
            else {
                const { image } = cropperCanvas.value.getResult();
                cropperCanvas.value.setCoordinates({
                    width: image.width,
                    height: image.height / aspectRatio.value,
                });
            }
        }
        return (_ctx, _cache) => {
            const _component_UIModalContent = _resolveComponent("UIModalContent");
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: showModal.value,
                "onUpdate:show": _cache[0] || (_cache[0] = ($event) => ((showModal).value = $event)),
                width: 1200
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        type: "custom",
                        id: "modal-header",
                        class: "border-b border-gray-200 pb-3"
                    }, {
                        customHeader: _withCtx(() => [
                            _createVNode(ModalHeader, {
                                loading: _unref(isLoading),
                                onReset: resetAll,
                                onClose: closeEditor
                            }, null, 8, ["loading"])
                        ]),
                        _: 1
                    })
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        loading: saveLoader.value,
                        negativeText: _ctx.$t('common.cancel'),
                        positiveText: _ctx.$t('common.save'),
                        type: "primary",
                        onNegativeClick: closeEditor,
                        onPositiveClick: downloadImage,
                        id: "image-editor-footer",
                        class: "border-t border-gray-200 pt-3 mt-0"
                    }, null, 8, ["loading", "negativeText", "positiveText"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_UIModalContent, {
                        class: "flex flex-row",
                        style: { "height": "550px" }
                    }, {
                        default: _withCtx(() => [
                            _createVNode(Options, {
                                canvasCtx: _unref(canvas),
                                "bg-height": bgImageHeight.value,
                                "bg-width": bgImageWidth.value,
                                "bg-image": bgImage.value,
                                cropper: cropperCanvas.value,
                                loaded: createFrames.value,
                                reset: reset.value,
                                onChange: setSelectedOption,
                                onDrawSettings: setBrushSettings,
                                onFabricChange: fabricChange,
                                onCropChange: cropperChange,
                                onFramesCreated: disableLoading,
                                onChangeAspectRatio: setAspectRatio
                            }, null, 8, ["canvasCtx", "bg-height", "bg-width", "bg-image", "cropper", "loaded", "reset"]),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    (showLoader.value)
                                        ? (_openBlock(), _createBlock(_unref(UISpin), {
                                            key: 0,
                                            size: "large",
                                            class: "absolute left-1/2 top-1/2 z-20"
                                        }))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_unref(Cropper), {
                                            src: cropperImage.value,
                                            transitions: true,
                                            "image-restriction": "fit-area",
                                            "default-boundaries": "fill",
                                            class: "cropper",
                                            "image-class": "cropper__image",
                                            "stencil-props": cropperOptions.value,
                                            ref_key: "cropperCanvas",
                                            ref: cropperCanvas,
                                            onChange: cropperChange,
                                            onReady: cropperReady
                                        }, null, 8, ["src", "stencil-props"])
                                    ]),
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{
                                                'hidden w-0 h-0': !_unref(showFabric) || showLoader.value,
                                                'w-full h-full': _unref(showFabric),
                                            }, "absolute top-0 left-0 z-10 items-center justify-center flex flex-col bg-gray-100"])
                                    }, [
                                        _createElementVNode("canvas", _hoisted_4, null, 512)
                                    ], 2),
                                    _hoisted_5
                                ], 512),
                                (selectedOption.value == _unref(Tools).CROP)
                                    ? (_openBlock(), _createBlock(CropSubTool, {
                                        key: 0,
                                        "canvas-ctx": _unref(canvas),
                                        cropper: cropperCanvas.value,
                                        onCropChange: cropperChange
                                    }, null, 8, ["canvas-ctx", "cropper"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
